<script>
  import PreviewLine from './previews/PreviewLine.svelte';

  export let preview = '';
  export let className = '';
  export let showIcon = true;
  export let compact = true;
</script>

<PreviewLine {preview} {className} {showIcon} {compact} />
